export const LOCAL_STORAGE = {
  TOKEN: 'TOKEN',
  CURRENT_SCREEN: 'CURRENT_SCREEN',
  COMMUNITY_USER_ID: 'COMMUNITY_USER_ID',
  ORIGIN_URL: 'ORIGIN_URL'
};

export const STORAGE_KEY = {
  bookStorage: 'book',
  book: 'bookData',
  section: 'sectionData',
  object: 'objectData',
  printSheet: 'sheetData',
  printLayout: 'printLayout',
  printLayoutType: 'printLayoutType',
  digitalLayout: 'digitalLayout',
  digitalLayoutType: 'digitalLayoutType',
  printSavedlayout: 'printSavedlayout',
  printFavoritesLayout: 'printFavoritesLayout',
  printSavedPortraitSettings: 'printSavedPortraitSettings',
  digitalSavedPortraitSettings: 'digitalSavedPortraitSettings'
};
